export default "__VITE_ASSET__TD6tPTL2__"